import { css } from "@emotion/react";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import { TELTONIKA_TELEMATICS_WEBSITE_CONTACTS } from "shared/constants/externalLinks";
import { body1BoldStyles } from "shared/styles/typography";

const CompanyLevelCallToAction = () => {
    return (
        <div
            css={css({
                justifyContent: "center",
                textAlign: "center",

                "& > span": {
                    ...body1BoldStyles,
                    display: "flex"
                },

                "& > span:first-of-type": {
                    paddingTop: "24px"
                }
            })}
        >
            <span>
                Get in touch with Teltonika Telematics Sales representative, ask
                your questions and learn more.
            </span>

            <Button
                data-testid="call-to-action-button"
                color={BUTTON_COLORS.Primary}
                size={BUTTON_SIZES.Small}
                variant={BUTTON_VARIANTS.TextOnly}
                onClick={() =>
                    window.open(
                        TELTONIKA_TELEMATICS_WEBSITE_CONTACTS,
                        "_blank",
                        "noopener"
                    )
                }
                css={css({
                    margin: "16px 0 24px 0"
                })}
            >
                Contact sales
            </Button>
        </div>
    );
};

export default CompanyLevelCallToAction;
